import ProcessScroll from "./ProcessScroll";
import StepsProcess from "./Steps";

const OurApproach = () => (
  <div className="h-[230vh] md:h-auto bg-light-pink flex flex-col">
    <ProcessScroll />
    <StepsProcess />
  </div>
);

export default OurApproach;
